import React from 'react';
import { Button } from 'src/@vymo/ui/atoms';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import { Widget } from 'src/@vymo/ui/molecules';
import { Keys, locale } from 'src/i18n';
import { useAppSelector } from 'src/store/hooks';
import ErrorState from '../../components/errorState';
import { getKeyMetricsList, getStatus } from '../../selector';
import KeyMetricCard from './card';
import styles from './index.module.scss';

function KeyMetricsWidget({ classNames }) {
  const keyMetrics = useAppSelector(getKeyMetricsList);
  const status = useAppSelector((state) => getStatus(state, 'key_metrics'));
  return (
    <Widget
      title={locale(Keys.KEY_METRICS)}
      content={
        <>
          {status === 'done' && (
            <div className={styles.keyMetricsWrapper}>
              {keyMetrics?.slice(0, 6)?.map((metric) => (
                <KeyMetricCard metric={metric} />
              ))}
            </div>
          )}
          {status === 'error' && <ErrorState />}
          {status === 'loading' && <SkeletonLoader rect />}
        </>
      }
      classNames={classNames}
      actions={
        <Button
          type="outlined"
          onClick={() => {
            window.location.hash = '/performance/key_metrics';
          }}
        >
          {locale(Keys.VIEW_ALL)}
        </Button>
      }
    />
  );
}

export default KeyMetricsWidget;
